module.exports = __webpack_public_path__ + "static/media/confirmed_active.b1167a4c.svg";